import React from 'react';
import { Droplets, Layers, CircleDollarSign } from 'lucide-react';

const PaintParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  paintTypes,
  paintQualities
}) => {
  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Droplets className="w-5 h-5 mr-2 text-green-500" />
        Параметры краски
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Тип краски */}
        <div>
          <label htmlFor="paintType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Тип краски
          </label>
          <select
            id="paintType"
            name="paintType"
            value={formData.paintType}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.paintType ? 'input-error' : ''}`}
          >
            {paintTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
          {errors.paintType && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.paintType}
            </p>
          )}
        </div>

        {/* Качество краски */}
        <div>
          <label htmlFor="paintQuality" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Качество краски
          </label>
          <select
            id="paintQuality"
            name="paintQuality"
            value={formData.paintQuality}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.paintQuality ? 'input-error' : ''}`}
          >
            {paintQualities.map((quality) => (
              <option key={quality.id} value={quality.id}>
                {quality.name} (₽{quality.priceRangeStart}-{quality.priceRangeEnd})
              </option>
            ))}
          </select>
          {errors.paintQuality && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.paintQuality}
            </p>
          )}
        </div>

        {/* Количество слоев */}
        <div>
          <label htmlFor="coatsNumber" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Layers className="w-4 h-4 mr-2 text-green-500" />
            Количество слоев
          </label>
          <select
            id="coatsNumber"
            name="coatsNumber"
            value={formData.coatsNumber}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.coatsNumber ? 'input-error' : ''}`}
          >
            <option value="1">1 слой</option>
            <option value="2">2 слоя (рекомендуется)</option>
            <option value="3">3 слоя</option>
            <option value="4">4 слоя</option>
          </select>
          {errors.coatsNumber && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.coatsNumber}
            </p>
          )}
        </div>

        {/* Цена краски */}
        <div>
          <label htmlFor="pricePerLiter" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <CircleDollarSign className="w-4 h-4 mr-2 text-green-500" />
            Цена краски за литр
          </label>
          <div className="relative">
            <input
              type="text"
              id="pricePerLiter"
              name="pricePerLiter"
              value={formData.pricePerLiter}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.pricePerLiter ? 'input-error' : ''}`}
              placeholder="Цена за литр"
            />
            <span className="absolute inset-y-0 right-3 flex items-center text-gray-500 dark:text-gray-400 pointer-events-none">
              ₽
            </span>
          </div>
          {errors.pricePerLiter && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.pricePerLiter}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 bg-green-100 dark:bg-green-900/30 p-3 rounded-lg border border-green-200 dark:border-green-800">
        <div className="flex items-start">
          <Droplets className="w-5 h-5 text-green-600 dark:text-green-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-green-700 dark:text-green-300 mb-1">
              О выборе краски
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400">
              Для лучшего результата рекомендуется наносить не менее 2 слоев краски. Качество краски существенно влияет на расход, долговечность и внешний вид покрытия. Для влажных помещений (ванная, кухня) рекомендуются водостойкие краски.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaintParametersSection;